import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import useIsMobile from 'lib/useIsMobile';

const styles = {
  container: {
    backgroundColor: '#EF493E',
    display: 'inline-block',
    marginTop: '25px',
    textAlign: 'center',
    width: '390px',
    border: '1px solid',
    borderRadius: '10px',
    height: '75px',
    color: 'white',
    marginBottom: '3%',
  },
  mobileContainer: {
    backgroundColor: '#EF493E',
    display: 'inline-block',
    marginTop: '25px',
    textAlign: 'center',
    width: '350px',
    border: '1px solid',
    borderRadius: '10px',
    height: '75px',
    color: 'white',
    marginBottom: '3%',
  },
  party: {
    backgroundColor: '#0076BB',
    width: '80px',
    float: 'left',
    height: '100%',
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
    fontSize: '26px',
    lineHeight: '22px',
    color: 'white',
    fontWeight: '700',
    fontFamily: 'GaeguBold',
    padding: '3%',
    paddingLeft: '1%',
  },
  partyMob: {
    backgroundColor: '#0076BB',
    width: '80px',
    float: 'left',
    height: '100%',
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
    fontSize: '24px',
    lineHeight: '22px',
    color: 'white',
    fontWeight: '700',
    fontFamily: 'GaeguBold',
    padding: '3%',
    paddingLeft: '1%',
  },
  col: {
    width: '19%',
    float: 'left',
    height: '70px',
  },
  count: {
    width: '50px',
    height: '40px',
    borderRadius: '5px',
    backgroundColor: 'white',
    textAlign: 'center',
    fontWeight: '700',
    fontSize: '30px',
    color: '#0076BB',
    marginBottom: '0px',
    fontFamily: 'NiveauGroteskRegular',
  },
  box: {
    paddingLeft: '10px',
    paddingTop: '10px',
  },
  leftValue: {
    width: '50px',
    display: 'inherit',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: '700',
    fontFamily: 'NiveauGroteskRegular',
    paddingTop: '5%',
  },
  counter: {
    position: 'relative',
    top: '3px',
  },
};

const EventTimer = ({
  eventDetails,
  isRefundType,
}) => {
  const mobile = useIsMobile();
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const packAndApplicationCount = useMemo(() => eventDetails?.packAndApplicationCount, [eventDetails]);
  const deadline = isRefundType ? [
    {
      name: 'Time Left',
      startTime: Date.parse(packAndApplicationCount?.refundPackData?.refundAllocationExpiryDate),
    },
  ] : [{
    name: 'First party',
    startTime: Date.parse('22 Jul 2023 01:00:00 GMT'),
  }, {
    name: 'Second party',
    startTime: Date.parse('27 Jul 2023 01:00:00 GMT'),
  }, {
    name: 'Third party',
    startTime: Date.parse('06 Aug 2023 09:00:00 GMT'),
  }];
  const game = deadline.find(val => val.startTime > Date.now()) || deadline[2];
  const getTime = () => {
    let time = packAndApplicationCount && packAndApplicationCount.refundPackData
    && packAndApplicationCount.refundPackData.refundAllocationExpiryDate && packAndApplicationCount.refundPackData.refundAllocationExpiryDate !== '' ? Date.parse(packAndApplicationCount.refundPackData.refundAllocationExpiryDate) - Date.now() : game?.startTime - Date.now();
    if (time < 0) {
      time = 0;
      return 0;
    }
    setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
    setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
    setMinutes(Math.floor((time / 1000 / 60) % 60));
    setSeconds(Math.floor((time / 1000) % 60));
    return 0;
  };
  useEffect(() => {
    const interval = setInterval(() => getTime(), 1000);

    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const renderTimer = () => {
    return (
      <div style={mobile ? styles.mobileContainer : styles.container}>
        <div style={mobile ? styles.partyMob : styles.party}>
          {game?.name}
        </div>
        <div style={styles.col}>
          <div style={styles.box}>
            <p style={styles.count}><span style={styles.counter}>{days < 10 ? `0${days}` : days}</span></p>
            <span style={styles.leftValue}>DAYS</span>
          </div>
        </div>
        <div style={styles.col}>
          <div style={styles.box}>
            <p style={styles.count}><span style={styles.counter}>{hours < 10 ? `0${hours}` : hours}</span></p>
            <span style={styles.leftValue}>HRS</span>
          </div>
        </div>
        <div style={styles.col}>
          <div style={styles.box}>
            <p style={styles.count}><span style={styles.counter}>{minutes < 10 ? `0${minutes}` : minutes}</span></p>
            <span style={styles.leftValue}>MIN</span>
          </div>
        </div>
        <div style={styles.col}>
          <div style={styles.box}>
            <p style={styles.count}><span style={styles.counter}>{seconds < 10 ? `0${seconds}` : seconds}</span></p>
            <span style={styles.leftValue}>SEC</span>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      {renderTimer()}
    </>
  );
};
EventTimer.propTypes = {
  eventDetails: PropTypes.any,
  isRefundType: PropTypes.bool,
};

export default EventTimer;
